import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { VerticalQuestion, VerticalQuestionInput } from '../question';

@Component({
  selector: 'app-vertical-question',
  templateUrl: './vertical-question.component.html',
  styleUrls: ['../../../../../theme/radio-button.scss','../question.scss', './vertical-question.component.scss']
})
export class VerticalQuestionComponent extends VerticalQuestion implements OnInit {

  @Input() question: VerticalQuestionInput | undefined;
  @Input() checkedOption: number | undefined;
  @Output() selected = new EventEmitter<number>();

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  onSelected($event: MatRadioChange): void {
    const selectedValue = $event.value;
    this.selected.emit(selectedValue);
  }
}
